<my-select-checkbox-all
  [(ngModel)]="selectedLanguages"
  (ngModelChange)="onModelChange()"
  [availableItems]="availableLanguages"
  [maxItems]="maxLanguages"
  i18n-placeholder placeholder="Add a new language"
  [allGroupLabel]="allLanguagesGroup"
>
</my-select-checkbox-all>
